import { useMediaQuery } from 'react-responsive';

import { getBreakpointSize } from '@/theme';
import type { Breakpoints } from '@/theme/media';

export const useIsXsUp = () =>
  useMediaQuery({ minWidth: getBreakpointSize('xs') });

export const useIsMdUp = () =>
  useMediaQuery({ minWidth: getBreakpointSize('md') });
export const useIsMdDown = () =>
  useMediaQuery({ maxWidth: getBreakpointSize('md') - 1 });

export const useIsSmUp = () =>
  useMediaQuery({ minWidth: getBreakpointSize('sm') });
export const useIsSmDown = () =>
  useMediaQuery({ maxWidth: getBreakpointSize('sm') - 1 });

export const useIsLgUp = () =>
  useMediaQuery({ minWidth: getBreakpointSize('lg') });
export const useIsLgDown = () =>
  useMediaQuery({ maxWidth: getBreakpointSize('lg') - 1 });

export const useIsXlUp = () =>
  useMediaQuery({ minWidth: getBreakpointSize('xl') });
export const useIsXlDown = () =>
  useMediaQuery({ maxWidth: getBreakpointSize('xl') - 1 });

export const useIsUnderLargeBreakpoint = () =>
  useMediaQuery({ maxWidth: 1440 - 1 });

type ResponsiveHook = Record<Breakpoints, () => boolean>;

const fromMapping: ResponsiveHook = {
  xs: useIsXsUp,
  sm: useIsSmUp,
  md: useIsMdUp,
  lg: useIsLgUp,
  xl: useIsXlUp,
};

const toMapping: ResponsiveHook = {
  xs: useIsXsUp,
  sm: useIsSmDown,
  md: useIsMdDown,
  lg: useIsLgDown,
  xl: useIsXlDown,
};

export const useIsBetween = (from: Breakpoints, to: Breakpoints) => {
  const isUp = fromMapping[from]();
  const isDown = toMapping[to]();
  return isUp && isDown;
};
